import { createAsyncThunk } from '@/redux/createAsyncThunk';
import { getAuthToken } from '@/redux/modules/account/user/user.selectors';
import { getDeployment } from '@/redux/modules/config';

import { getCategoryRelatedSearchTiles } from './categoryRelatedSearches.api';
import { RelatedSearchTile } from './categoryRelatedSearches.types';

export const fetchCategoryRelatedSearchTiles = createAsyncThunk<
    RelatedSearchTile,
    { categoryIds: number[]; concatenatedFacetIds?: string[] }
>('la/domain/category/fetchCategoryRelatedSearchTiles', async ({ categoryIds, concatenatedFacetIds }, { getState }) => {
    const state = getState();
    const authToken = getAuthToken(state);
    const deployment = getDeployment(state);

    const response = await getCategoryRelatedSearchTiles({
        authToken,
        categoryIds,
        concatenatedFacetIds,
        deployment,
    });

    return response.payload;
});
